import { Application } from "./Application";

export abstract class BaseCommand
{
    protected argv: string[];
    public app!: Application;
    public name!: string;
    public parent: BaseCommand | null = null;
    constructor(argv: string[])
    {
        this.argv = argv;
    }
    public getName()
    {
        let ans: string = "";
        let cur: BaseCommand | null = this;
        while (cur != null)
        {
            ans = cur.name + " " + ans;
            cur = cur.parent;
        }
        return ans.trim();
    }
    protected abstract getError(): Promise<string | null>;
    protected abstract exec(): Promise<void>;
    async run(): Promise<void>
    {
        try
        {
            let error = await this.getError();
            if (this.isHelp())
                this.help();
            else if (error == null)
                await this.exec();
            else
            {
                this.app.logger.error(error);
                this.help();
            }
        } catch (error: any)
        {
            this.app.logger.error(error.message ?? error);
            process.exit(1);
        }
    }
    isHelp(): boolean
    {
        return false;
    }
    abstract help(): void;
}